import { ReactNode } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Speaker } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, adminTier, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
        <div className="animate-pulse">
          <Speaker className="w-12 h-12 text-primary" />
        </div>
      </div>
    );
  }

  if (!user || user.isAnonymous) {
    return <Navigate to="/" replace />;
  }

  if (adminTier !== 'owner') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark p-6">
        <div className="w-full max-w-md text-center space-y-4">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Not available</h1>
          <Link to="/dashboard" className="text-primary hover:text-primary-hover font-medium">
            Go to your dashboard
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
